import moment from "moment";
import "moment-duration-format";
import NumberUtils from "util/NumberUtils";
export const formatDuration = (ms) => moment.duration(ms, "milliseconds").format("m[m], s[s], S[ms]");
export const formatTokenUsage = (usage) => [
  `${NumberUtils.formatNumber(usage.input_tokens)} in`,
  `${NumberUtils.formatNumber(usage.output_tokens)} out`,
  `${NumberUtils.formatNumber(usage.total_tokens)} total`
].join(" \xB7 ");
export const hasConfiguredModelProvider = (config) => Boolean(config.default_provider && config.default_model_id);
